import React from 'react';

import { Box, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const styles = () => ({
  emptyTable: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
});
function EmptyTable({ children, className, classes, image, style, subtitle, title }) {
  const getTitle = () => {
    if (title && typeof title === 'string') {
      return (
        <Typography align="center" variant="h2" component="h2">
          {title}
        </Typography>
      );
    }
    if (title && typeof title !== 'undefined') {
      return title;
    }

    return '';
  };

  const getSubtitle = () => {
    if (subtitle && typeof subtitle === 'string') {
      return (
        <Typography align="center" variant="bodyLight" component="p">
          {' '}
          {subtitle}{' '}
        </Typography>
      );
    }
    if (subtitle && typeof subtitle !== 'undefined') {
      return subtitle;
    }

    return '';
  };

  return (
    <div className={classNames(classes.emptyTable, className)} style={style}>
      {image}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {getTitle()}
        {getSubtitle()}
      </Box>
      {children}
    </div>
  );
}

EmptyTable.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
};

export default withStyles(styles)(EmptyTable);
